import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServiceDetail from "@/pages/ServiceDetail";
import UeberUns from "@/pages/UeberUns";
import Ablauf from "@/pages/Ablauf";
import Einsatzgebiet from "@/pages/Einsatzgebiet";
import FAQPage from "@/pages/FAQPage";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookiePolicy from "@/pages/CookiePolicy";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import StickyCallButton from "@/components/site/StickyCallButton";
import ScrollToTop from "@/components/site/ScrollToTop";

function App() {
    return (
        <div className="App dark min-h-screen">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <main className="pt-16">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/leistungen" element={<Leistungen />} />
                        <Route path="/leistungen/:slug" element={<ServiceDetail />} />
                        <Route path="/ueber-uns" element={<UeberUns />} />
                        <Route path="/ablauf" element={<Ablauf />} />
                        <Route path="/einsatzgebiet" element={<Einsatzgebiet />} />
                        <Route path="/faq" element={<FAQPage />} />
                        <Route path="/kontakt" element={<Kontakt />} />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="/datenschutz" element={<Datenschutz />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
                <Footer />
                <CookieBanner />
                <StickyCallButton />
                <Toaster
                    position="top-center"
                    richColors
                    closeButton
                    theme="dark"
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
